import React from 'react';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const WHATSAPP = 'https://wa.me/16726676878?text=Hi%20Murat%2C%20I%20would%20like%20to%20book%20an%20oil%20change%20service.';

const go = (e, href) => { e.preventDefault(); document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' }); };

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = [
    [t('footer.links.home'), '#home'],
    [t('footer.links.about'), '#about'],
    [t('footer.links.services'), '#services'],
    [t('footer.links.booking'), '#booking'],
    [t('footer.links.contact'), '#contact'],
  ];

  const serviceItems = [
    t('footer.services.oil'),
    t('footer.services.obd'),
    t('footer.services.brake'),
    t('footer.services.fluid'),
    t('footer.services.checkup'),
    t('footer.services.models'),
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <div className={styles.logo}>🔧 <span>Mr.Bulum</span></div>
          <p className={styles.tagline}>{t('footer.tagline')}</p>
          <div className={styles.contacts}>
            <a href="tel:+16726676878" className={styles.contact}><FiPhone size={13}/> 672-667-6878</a>
            <a href="mailto:muratbulum@gmail.com" className={styles.contact}><FiMail size={13}/> muratbulum@gmail.com</a>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className={`${styles.contact} ${styles.wa}`}><FaWhatsapp size={13}/> WhatsApp</a>
            <span className={styles.contact}><FiMapPin size={13}/> Vancouver & Lower Mainland, BC</span>
          </div>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>{t('footer.navigate')}</h4>
          <ul className={styles.colLinks}>
            {navLinks.map(([l, h]) => (
              <li key={l}><a href={h} onClick={e => go(e, h)}>{l}</a></li>
            ))}
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>{t('footer.serviceIncludes')}</h4>
          <ul className={styles.colLinks}>
            {serviceItems.map(s => (
              <li key={s}><a href="#services" onClick={e => go(e, '#services')}>{s}</a></li>
            ))}
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>{t('footer.bookNow')}</h4>
          <p className={styles.colText}>{t('footer.bookText')}</p>
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className={styles.waBtn}>
            <FaWhatsapp size={15}/> {t('footer.waBooking')}
          </a>
          <div className={styles.hours}>
            <span className={styles.hoursTitle}>{t('footer.availability')}</span>
            <span>{t('footer.availabilityVal')}</span>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <p className={styles.copy}>© {new Date().getFullYear()} {t('footer.rights')}</p>
        <p className={styles.built}>Vancouver, BC, Canada 🇨🇦</p>
      </div>
    </footer>
  );
}
